import type { IconSvgObject } from './types';

const Grid2X2CheckIcon: IconSvgObject = [
  ["path", { d: "M11.5 21C7.25736 21 5.13604 21 3.81802 19.682C2.5 18.364 2.5 16.2426 2.5 12C2.5 7.75736 2.5 5.63604 3.81802 4.31802C5.13604 3 7.25736 3 11.5 3C15.7426 3 17.864 3 19.182 4.31802C20.5 5.63604 20.5 7.75736 20.5 12", stroke: "currentColor", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M11.5 3V21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M20.5009 11.9922H2.50586", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M15.5 19.6667C15.5 19.6667 16.25 19.6667 17 21C17 21 19.3824 17.6667 21.5 17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Grid2X2CheckIcon;
